module.exports = __webpack_public_path__ + "img/about-01.a195def4.jpg";